import React, { Component } from "react";
import Loader from "../loader/loader";
import parse from "html-react-parser";
import { verifyOBToken } from "../../action/application/verifyOBToken";
import withRouter from '../../withRouter';
import { frontEndLogs } from '../../action/logs/frontEndLogs';
import { openBankingInitialize } from '../../action/applicationSave/applicationSave';
import {getEmailFromStorage,setEmailInStorage,setSessionIdInStorage,generateUuid} from "../../utils/helpers/storageUtils";
import { PropTypes } from 'prop-types';
class ObVerificationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      message: "",
      token: "",
      application_id: "",
      email: "",
      session_id: "",
      userloginType: "",
      openBankingRedirectURl: "",
      helpCenterURL: "https://www.shophumm.com/uk/help-centre/",
      hepCenterButtonLabel: "Help Centre",
    };
  }

  componentDidMount() {
    generateUuid();
    this.tokenVerification();
  }

  handleOBResponse = async () => {
    let email = getEmailFromStorage();
    try {
      let requestPayloadOBInitialize = {
        "application_id": sessionStorage.getItem("applicationId"),
        "application_external_id": sessionStorage.getItem("application_Id"),
        "email": email ?? this.state.email,
        "userId": sessionStorage.getItem('userID'),
      }
      let obInitializeResponse = await openBankingInitialize(requestPayloadOBInitialize);
      if (obInitializeResponse && obInitializeResponse?.data?.statusCode === 201) {
        if (obInitializeResponse?.data?.data?.url) {
          this.setState({ openBankingRedirectURL: obInitializeResponse.data.data.url, openWarningOBConsent: true }, () => {
            window.location.href = this.state.openBankingRedirectURL;
          })
        }
      }
    }
    catch (error) {
      await frontEndLogs('Catch Error ' + sessionStorage.getItem("applicationId"), true, 400, 'handleWarningOBResponse', error?.message);
    }
  }

  tokenVerification = async () => {
    let verifyOBResponse = '';
    let jwt = this.props.params.doc;
    let flow = this.props.params.flow;
    sessionStorage.setItem('applicationStatus', '')
    if(flow){
      localStorage.setItem('fromWhere','apply_now');
      sessionStorage.setItem('fromWhere', 'apply_now');
    }
    const obj = {
      "token": jwt
    }
    if (jwt) {
      verifyOBResponse = await verifyOBToken(obj);
    }
    if (verifyOBResponse?.data?.statusCode === 200) {
      if(verifyOBResponse?.data?.data?.status){
        this.setState({ message: verifyOBResponse?.data?.message, loading: false });
        this.setState({ loading: false });
        window.$('#OBverificationShowModel').modal('show');
      }
      else{
      const decoded = verifyOBResponse?.data?.data?.decoded?.data || {};
      const { application_id, application_external_id, email, session_id, userlogintype } = decoded;
      this.setState({
        token: jwt,
        application_id,
        application_external_id,
        email,
        session_id,
        userloginType: userlogintype,
      });
      sessionStorage.setItem("applicationId", application_id);
      sessionStorage.setItem("application_Id", application_external_id);
      setEmailInStorage(email);
      setSessionIdInStorage(session_id);
      sessionStorage.setItem("userloginType", userlogintype);
      sessionStorage.setItem('isObFlow', 'true');
      this.handleOBResponse();
    }
    }
    else {
      this.setState({ message: verifyOBResponse?.data?.message, loading: false });
      this.setState({ loading: false });
      window.$('#OBverificationShowModel').modal('show');
    }
  };

  handleObVerificationLinkPopUp = () => {
    this.setState({ message: "" }, () => {
      window.$('#OBverificationShowModel').modal('hide');
      window.location.href = this.state.helpCenterURL;
    })
  };

  render() {
    return (
      <>
        <Loader loaderStatus={this.state.loading} />
        {!this.state.loading && (
          <div style={{ backgroundColor: "white", minHeight: "100vh" }}>
          </div>
        )}

        {/* Modal */}
        <dialog
          className="modal fade model-error"
          id="OBverificationShowModel"
          tabIndex="-1"
          data-keyboard="false"
          data-backdrop="static"
          aria-labelledby="OBverificationShowModel"
          aria-hidden="true"
        >
          <div className="modal-dialog" >
            <div className="modal-content">
              <div className="modal-header"></div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <p className="text-center mt-4 mx-3">
                  {parse(this.state.message)}
                </p>
              </div>

              <div className="modal-footer mb-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.handleObVerificationLinkPopUp}
                >{this.state.hepCenterButtonLabel ? this.state.hepCenterButtonLabel : "Ok"}
                </button>
              </div>
            </div>
          </div>
        </dialog>
      </>
    );
  }
}

ObVerificationPage.propTypes = {
  params: PropTypes.shape({
    doc: PropTypes.any,
    flow: PropTypes.string,
  })
}

export default withRouter(ObVerificationPage);
